import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { MatDialog } from '@angular/material';
import { ResultDialogComponent } from '../result-dialog/result-dialog.component';

import { AuthGuardService, LoadingService, UserService } from '@core/services';
import { User } from '@shared/models';

import { fadeAnimation } from '../../app.animations';

@Component({
  selector: 'app-customer-service',
  templateUrl: './customer-service.component.html',
  styleUrls: ['./customer-service.component.css'],
  animations: [fadeAnimation]
})
export class CustomerServiceComponent implements OnInit {

  customerServiceForm: FormGroup;
  subscription: Subscription;
  loaderSubscription: Subscription;
  user: User;
  displayFAQ = true;
  private routeSubscription: Subscription;
  isLoaderHidden: boolean;

  constructor(private _userService: UserService,
              private _authGuard: AuthGuardService,
              private dialog: MatDialog,
              private route: ActivatedRoute,
              private _formBuilder: FormBuilder,
              private _loadingService: LoadingService) {
    this.customerServiceForm =  this._formBuilder.group({
      customerServiceMessage: ['', [Validators.required, Validators.minLength(8)]]
    });

  }

  ngOnInit() {
    this.subscription = this._userService.getUser()
      .subscribe(user => this.user = user);

    this.loaderSubscription = this._loadingService.getHiddenValue()
      .subscribe(hidden => this.isLoaderHidden = <boolean>hidden);

    this.routeSubscription = this.route.params.subscribe(params => {
      console.log('in route sub:', params);
      if(params['type']){
        console.log(params['type']);

        this.displayFAQ = false; // (+) converts string 'id' to a number
      }
    });

  }

  ngOnDestroy() {
    if(this.subscription)
      this.subscription.unsubscribe();

    if(this.routeSubscription)
      this.routeSubscription.unsubscribe();

    if(this.loaderSubscription)
      this.loaderSubscription.unsubscribe();
  }

  onSubmit() {
      if(!this.customerServiceForm.valid) return;

      this._loadingService.showLoader();

      this._authGuard.authenticatedPost('Email/EmailCustomerService', this.setUpEmailData())
        .subscribe(
            result => {
                let dialogRef = this.dialog.open(ResultDialogComponent, {
                    data: {
                        message: 'Your message has been sent',
                        alertType: 'success',
                        title: 'Customer Service'
                    }
                });
              this._loadingService.hideLoader();
              this.customerServiceForm.reset();
            },
            error => {
                let dialogRef = this.dialog.open(ResultDialogComponent, {
                    data: {
                        message: error,
                        alertType: 'danger',
                        title: 'Customer Service'
                    }
                });
              this._loadingService.hideLoader();
            }
        );
  }
  setUpEmailData(){
    return {
      'Email': this.user.email,
      'AccountId': this.user.accountSummaryArray[this.user.accountIndex].id ,
      'Message': this.customerServiceForm.value.customerServiceMessage
    };
  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/customer-service/customer-service.component.ts